import styles from './styles.module.scss';

export default function AmountFrom({ current, from }) {
  return (
    <p className={styles.amountForm}>
      {current} de {from}
    </p>
  );
}
